import { render, staticRenderFns } from "./mySkeleton.vue?vue&type=template&id=6d4bc514&scoped=true"
import script from "./mySkeleton.vue?vue&type=script&lang=js"
export * from "./mySkeleton.vue?vue&type=script&lang=js"
import style0 from "./mySkeleton.vue?vue&type=style&index=0&id=6d4bc514&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bc514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4bc514')) {
      api.createRecord('6d4bc514', component.options)
    } else {
      api.reload('6d4bc514', component.options)
    }
    module.hot.accept("./mySkeleton.vue?vue&type=template&id=6d4bc514&scoped=true", function () {
      api.rerender('6d4bc514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/mySkeleton.vue"
export default component.exports